import { FormStateV3, FieldStateV3 } from '../../../../commonv3/states/form/FormStateV3';
import { NumberValidators, StringValidators } from '../../../../commonv3/states/form/validators';
import { ISODate } from '../../../../commonv3/types/dates';
import { computed, makeObservable } from 'mobx';
import { SubscriptionSuspensionRequest } from '../../../apis/subscriptions';

export class SubscriptionSuspensionCreatePageFormState extends FormStateV3<SubscriptionSuspensionRequest> {
  constructor() {
    super({
      starts_at: new FieldStateV3<ISODate>([StringValidators.required()]),
      duration: new FieldStateV3<number>([NumberValidators.required()]),
    });

    makeObservable(this, {
      isValid: computed,
    });
  }

  get isValid(): boolean {
    let valid = true;
    Object.keys(this.fields).forEach((key) => {
      const value = this.fields[key].getDirtyValue();
      if (value == null || value === '') {
        valid = false;
      }
    });
    return valid;
  }
}
